module.exports = __webpack_public_path__ + "img/8.92814816.jpg";